import { render, staticRenderFns } from "./addRoomRepairList.vue?vue&type=template&id=fc283b88&scoped=true"
import script from "./addRoomRepairList.vue?vue&type=script&lang=js"
export * from "./addRoomRepairList.vue?vue&type=script&lang=js"
import style0 from "./addRoomRepairList.vue?vue&type=style&index=0&id=fc283b88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc283b88",
  null
  
)

export default component.exports